<template>
<div class="container-fluid bg-default-color">
	<equipment-toolbar heading="Equipment Forms">

		<equipment-list-nav-tabs></equipment-list-nav-tabs>

	</equipment-toolbar>

	<p>Recently submitted company forms that have been attached to a piece of equipment.</p>

	<table-list record-name="Equipment Form"
		:records="mutatedCompanyForms"
		:fields="companyFormFields(true)"
		has-edit="/form/view/"
		:edit-new-tab="true"
		id-field="slug"
		edit-button-text="View"
		edit-button-icon="fa-eye"
		:clickable-row="true"
		:sortable="true"
		:hide-record-count="true">
	</table-list>

</div>
</template>
<script type="text/javascript">
import EquipmentToolbar from "./EquipmentToolbar"	
import TableList from "@/components/TableList"
import EquipmentListNavTabs from "./EquipmentListNavTabs"

import EquipmentFormViewModal from "@/components/company_forms/EquipmentFormViewModal"

import EquipmentMixins from "@/mixins/EquipmentMixins.js"
import FormMixins from "@/mixins/FormMixins.js"

export default {
	name: "EquipmentForms",
	components: {
		EquipmentToolbar,
		TableList,
		EquipmentListNavTabs,
		EquipmentFormViewModal
	},
	mixins: [EquipmentMixins,FormMixins],
	data() {
		return {
			formModal: {
				visible: false,
				formRecord: null
			}
		}
	},
	created() {
		let vm = this

		this.fetchEquipmentForms(true)

	}
}
</script>